import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AIFeedback({ open, onClose, setOpen }: ModalProps) {
  return (
    <Modal className="modal success_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="ai_feedback">
            <div className="ai_header">
              <img src="/static/images/ai_icon.svg" alt="AI" />
              <h4>AI Review Completed</h4>
            </div>

            <p className="ai_message">
              Your journal has been successfully analyzed by our AI system.
              It has passed all quality checks and is now awaiting <strong>admin approval</strong>.
            </p>

            <div className="ai_status">
              <span className="dot pending"></span>
              Pending Admin Approval
            </div>

            <p className="ai_note">
              Once approved, your journal will be published and visible to readers.
            </p>
          </div>

        </div>
      </div>
    </Modal>
  );
}
